




















































exports.default = {
  components:
    userMiniature: require('../users/miniature')

  props:
    template: {}
    options:
      default: -> {}

  data: ->
    current_user: Session.current_user
    default_options:
      show_open_statistic: true
      show_reply_statistic: true
      show_conversion_statistic: true
      show_user: false
      row_click_action: 'edit'
      action: 'dropdown-action'

  methods:
    editPath: (template) ->
      "/templates/#{template.id}/editar"

    rowClick: (template, event) ->
      return if !@current_user.can_manage_templates
      unless jQuery(event.target).closest('.clickable-element').length
        if !@current_user.isMonitoringManager()
          # @$router.push(@rowClickPath(template))
          if @default_options.row_click_action == 'edit'
            @$router.push @editPath(template)
          else
            @selectTemplate(event, template)
        else
          @showModal()

    selectTemplate: (event, template) ->
      event.originalEventName = 'template-selected'
      @$emit 'template-selected', { event, template }

    showModal: ->
      @$emit('showModal', @template)
      IntercomCtrl.trackEvent("Template - Pré-visualizado")

    confirmDestroy: ->
      @$emit('confirm-destroy', @template)

  created: ->
    @default_options = Object.assign(@default_options, @options)
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/templates/list_item.vue